import React from 'react';
import Text from 'components/Text';

interface BlockQuoteProps {
    children: React.ReactNode;
}

const BlockQuote: React.FC<BlockQuoteProps> = ({ children }) => (
    <Text $as="blockquote" typography={['Primary/24_110_510_-3', null, null, null, 'Primary/30_100_510_-5']} mb="16px">
        {children}
    </Text>
);

export default BlockQuote;
